import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { concatMap, of } from "rxjs";
import { NebulaSplashScreenService } from "../../../../@scientifica-cms-fe/services/splash-screen";
import { AuthService } from "../../../core/auth/auth.service";

import { UserService } from 'app/core/user/user.service';
import { jwtDecode } from 'jwt-decode';
import { LocalStorageService } from 'app/services/local-storage.service';
import { environment } from 'environments/environment';
import { UserDef } from 'app/core/auth/models/auth-user';

@Component({
    selector: 'app-google-redirect',
    templateUrl: './google-redirect.component.html',
    styleUrls: ['./google-redirect.component.scss']
})
export class GoogleRedirectComponent implements OnInit {

    route = inject(ActivatedRoute);
    router = inject(Router);
    userService = inject(UserService);
    authService = inject(AuthService);
    localstorageService = inject(LocalStorageService);
    splashscreenService = inject(NebulaSplashScreenService);

    ngOnInit(): void {
        this.splashscreenService.show();

        this.route.queryParams.subscribe((params) => {
            const jwtUser = params['jwtUser'];

            if (jwtUser) {
                const userFromJWT: UserDef = jwtDecode(jwtUser);
                this.userService.user = userFromJWT;

                this.authService.accessToken = jwtUser;
                this.localstorageService.setItem(environment.common.storageKeys.authToken, jwtUser);


                // Set the authenticated flag to true
                // this.authService._authenticated = true;
                setTimeout(() => {

                    this.splashscreenService.hide();
                }, 200)

                this.router.navigate(['/']);
            }
        });
    }

}
